/**
 * @param {Partial<WistiaDateTimeObject> | null} dateTime - a dateTime object
 * @returns {Date | null} - the converted date or null if anything is missing
 */
export const dateTimeToDate = (
  dateTime: Partial<WistiaDateTimeObject> | null | undefined,
): Date | null => {
  const { year, month, dayOfMonth, hours, minutes } = dateTime ?? {};

  if (year !== undefined && month !== undefined && dayOfMonth !== undefined) {
    return new Date(year, month, dayOfMonth, hours ?? 0, minutes ?? 0);
  }
  return null;
};
